<template>
    <div class="get-job-form" v-if="load">
        <div class="get-job-form-image">
            <div class="overlay">
                <navbar />
                <h2 class="main-title">{{ $t('job_form.title') }}</h2>
            </div>
        </div>
        <job-form v-scrollanimation :data="data" :status="status" />
        <custom-footer />
    </div>
    <loader3 v-else />
</template>

<script>
import Navbar from "@/components/Navbar.vue"
import JobForm from "@/components/JobForm.vue"
import CustomFooter from "@/components/CustomFooter.vue";
import Loader3 from '@/components/Loader3.vue';

export default {
    name: "GetjobForm",
    components: {
        Navbar,
        JobForm,
        CustomFooter,
        Loader3
    },
    data() {
        return {
            lang: '',
            load: false,
            data: [],
            expiry_date: null,
            today_date: null,
            status: false,
        };

    },
    methods: {
        getJob() {
            this.lang = localStorage.getItem('lang')
            this.axios.get(this.$store.state.url + "jobs")
                .then(res => {
                    this.load = true
                    this.data = res.data.list
                    this.data = this.data.filter(item =>
                        (item.expiration_date >= this.today_date) && (item.status)
                    )
                    console.log(this.data)
                    if (this.data.length == 0)
                        this.status = false
                    else
                        this.status = true
                });
        },
    },
    mounted() {
        document.documentElement.scrollTop = 0;
        this.getJob()
        this.today_date = new Date().toISOString().split('T')[0];
    }
};
</script>

<style>
.get-job-form {
    position: absolute;
    z-index: 100;
}

.get-job-form .get-job-form-image {
    background-image: url(../assets/img/join-us.webp);
    position: relative;
    height: 80vh;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.get-job-form .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #126801b6, #15203bce);
}

.get-job-form .main-title {
    text-align: center;
    font-weight: bold;
    color: #fff;
    margin-bottom: 60px;
    padding-top: 130px;
}

@media (min-width: 992px) {
    .get-job-form .main-title {
        font-size: 50px;
    }
}

@media (max-width: 991px) {
    .get-job-form .main-title {
        font-size: 30px;
    }
    .get-job-form .get-job-form-image {
        height: 60vh;
    }
}

.get-job-form .before-enter {
    opacity: 0;
    transform: translateY(150px);
    transition: all 1s;
}

.get-job-form .enter {
    opacity: 1;
    transform: translateY(0px);
}
</style>
